module.exports = __webpack_public_path__ + "static/media/YB5M02_1.bd9c88c8.jpg";